import React, { useEffect, useState, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InlineEditContainer } from 'transfix-ui/components/InlineEditContainer'
import { updateSidebarShipment } from 'apps/booking/utils/actions/sidebar'
import { isUpdatingShipment } from 'apps/booking/utils/selectors/shipment'
import { DISPLAY } from 'constants/display'
import TruckAutosuggest from './TruckAutosuggest'

interface ITruckInlineEditProps {
  truckNumber?: string
  carrierId: string
  shipmentId: number
}

/**
 * Truck form component using Inline Edit Container. Toggles TruckAutosuggest view
 */
const TruckInlineEdit = memo<ITruckInlineEditProps>(({ carrierId, shipmentId, truckNumber }) => {
  const dispatch = useDispatch()
  const [isTruckEditModeEnabled, setTruckEditModeEnabled] = useState(false)
  const [currentTruckNumber, setCurrentTruckNumber] = useState<string | undefined>(undefined)
  const setEditModeToggle = () => setTruckEditModeEnabled(!isTruckEditModeEnabled)
  const isLoading = useSelector(isUpdatingShipment)
  // if current truck number input is different from truck number on shipment details
  const changingTruckNumber = currentTruckNumber && currentTruckNumber !== truckNumber

  useEffect(() => {
    // Save truck number entry when clicked outside InlineEditContainer
    // and truck values differ
    if (!isTruckEditModeEnabled && changingTruckNumber) {
      dispatch(
        updateSidebarShipment(shipmentId, {
          info: {
            truckNumber: currentTruckNumber,
          },
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isTruckEditModeEnabled])

  return (
    <InlineEditContainer
      name='truckNumber'
      className='dib'
      dataTest='truck-number-inline-edit'
      editModeEnabled={isTruckEditModeEnabled}
      onEditModeRequested={setEditModeToggle}
      editMode={
        <TruckAutosuggest
          carrierId={carrierId}
          value={truckNumber}
          onChange={setCurrentTruckNumber}
        />
      }>
      <p className='b text-secondary'>Truck Number</p>
      {isLoading && changingTruckNumber ? <div className='spinner' /> : truckNumber || DISPLAY.none}
    </InlineEditContainer>
  )
})

export default TruckInlineEdit
